"use client";

// src/ReactQueryStreamedHydration.tsx
import {
  defaultShouldDehydrateQuery,
  dehydrate,
  hydrate,
  isServer,
  useQueryClient
} from "@tanstack/react-query";
import * as React from "react";
import { createHydrationStreamProvider } from "./HydrationStreamProvider.js";
import { jsx } from "react/jsx-runtime";
var stream = createHydrationStreamProvider();
function ReactQueryStreamedHydration(props) {
  const queryClient = useQueryClient(props.queryClient);
  const [trackedKeys] = React.useState(() => /* @__PURE__ */ new Set());
  if (isServer) {
    queryClient.getQueryCache().subscribe((event) => {
      switch (event.type) {
        case "added":
        case "updated":
          trackedKeys.add(event.query.queryHash);
      }
    });
  }
  return /* @__PURE__ */ jsx(
    stream.Provider,
    {
      onFlush: () => {
        const shouldDehydrate = props.options?.dehydrate?.shouldDehydrateQuery ?? defaultShouldDehydrateQuery;
        const dehydratedState = dehydrate(queryClient, {
          ...props.options?.dehydrate,
          shouldDehydrateQuery(query) {
            return trackedKeys.has(query.queryHash) && shouldDehydrate(query);
          }
        });
        trackedKeys.clear();
        if (!dehydratedState.queries.length) {
          return [];
        }
        return [dehydratedState];
      },
      onEntries: (entries) => {
        for (const hydratedState of entries) {
          hydrate(queryClient, hydratedState, props.options?.hydrate);
        }
      },
      transformer: props.transformer,
      children: props.children
    }
  );
}
export {
  ReactQueryStreamedHydration
};
//# sourceMappingURL=ReactQueryStreamedHydration.js.map